// extracted by mini-css-extract-plugin
module.exports = {"outerBox":"LoginPage_outerBox__3c0Ya","mainForm":"LoginPage_mainForm__3Gkxd","container":"LoginPage_container__dCWn8","logo_img":"LoginPage_logo_img__RD4YQ"};